import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText, { FormHelperTextProps } from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
  },
}));

const FormHelper = (props: FormHelperTextProps) => {
  const classes = useStyles();
  return (
    <FormHelperText className={classes.root} {...props}>
      {props.children}
    </FormHelperText>
  );
};

export default FormHelper;
